import {Component} from '@angular/core';
import {ClassificationType, TypologyApiService} from '@npck/af-frontend-api';
import {DATE_SERVER_FORMAT, download, downloadFromBlob, RouterService, rxSpinner, Spinner} from '@npck/libs/commons';
import {SnackbarService} from '@npck/libs/ui-kit';
import dayjs from 'dayjs';
import {finalize} from 'rxjs/operators';
import {CLASSIFICATION_SUBTYPE, CLASSIFICATION_TYPE} from '../../../domain/query-params.keys';
import {Path} from '../../../path';
import {AnalyticsTab} from '../analytics.component';
import {
    ClassificationPanelViewModel,
} from './classification-matrix/classification-group-panel/classification-panel/classification-panel.component';

@Component({
    selector: 'af-classification-fraud-dashboards',
    standalone: false,
    templateUrl: './classification-fraud-dashboards.component.html',
    styleUrl: './classification-fraud-dashboards.component.scss',
})
export class ClassificationFraudDashboardsComponent {
    Path = Path;
    tabPathToTab: Record<string, AnalyticsTab> = {classification: 'tabClassification'};
    selectedType: ClassificationType;
    isExporting: boolean = false;
    Spinner = Spinner;

    constructor(
        private typologyApiService: TypologyApiService,
        private routerService: RouterService,
        private snackbarService: SnackbarService,
    ) {
    }

    downloadDocument(): void {
        download('assets/documents/Руководство_пользователя_типология.pdf');
    }

    downloadExport(): void {
        if (this.isExporting) {
            return;
        }
        this.isExporting = true;
        const quarterStartDate = dayjs().subtract(3, 'months').startOf('months');
        const monthStartDate = dayjs().subtract(1, 'month').startOf('month');
        const monthEndDate = monthStartDate.endOf('month');
        const futureStartDate = dayjs().startOf('month');
        const futureEndDate = futureStartDate.endOf('month');

        this.typologyApiService.exportClassificationDetails({
            quarterStartDate: quarterStartDate.format(DATE_SERVER_FORMAT),
            quarterEndDate: monthEndDate.format(DATE_SERVER_FORMAT),
            monthStartDate: monthStartDate.format(DATE_SERVER_FORMAT),
            monthEndDate: monthEndDate.format(DATE_SERVER_FORMAT),
            forecastFutureStartDate: futureStartDate.format(DATE_SERVER_FORMAT),
            forecastFutureEndDate: futureEndDate.format(DATE_SERVER_FORMAT),
            forecastPastStartDate: monthStartDate.format(DATE_SERVER_FORMAT),
            forecastPastEndDate: monthEndDate.format(DATE_SERVER_FORMAT),
            classificationType: this.selectedType,
        }).pipe(
            rxSpinner('initial'),
            finalize(() => this.isExporting = false)
        ).subscribe({
            next: (file: Blob) => {
                downloadFromBlob(
                    file,
                    `typology_by_${this.selectedType}.xlsx`
                );
                this.snackbarService.showSnackBar('i18n_af_snackBarMessageFileSuccessfullyExported');
            },
            error: err => {
                throw err;
            }
        });
    }

    openDetails($event: ClassificationPanelViewModel): void {
        this.routerService.navigate(Path.ANALYTICS_CLASSIFICATIONS_FRAUD_DETAILS, {
            pathParams: {
                [CLASSIFICATION_TYPE]: this.selectedType.toLowerCase(),
                [CLASSIFICATION_SUBTYPE]: $event.dictionaryItem.code.toLowerCase(),
            },
        });
    }

}
